import(/* webpackMode: "eager" */ "/root/repo/src/app/(portal)/poweron-pro/layout.tsx");
